/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaTextareaLabel/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaTextareaLabel({
  children,
  viewPath = "/DesignSystem/TysiaTextarea/TysiaTextareaLabel",
  text,
  weight = "medium",
  size,
  required
  
}) {
let dtTysiainputlabelColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputLabel.color.primary.base'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaTextareaLabel.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 color={dtTysiainputlabelColorPrimaryBase}
 size="normal"
 weight={weight}
 whiteSpace="nowrap"
 overflowX="hidden"
 marginBottom={size === "small" ? "2px" : "6px"}
/>
<fromFlow.When is={required}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="*"
 marginLeft="2px"
 color={dtColorsRed600}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}